import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"

import { analyseQuery, initBranding } from "../companiesHouse/pageFunctions/homeFunctions"
import { actions as commonActions } from "../../modules/commonModule"
import { actions as appActions } from "../../modules/appModule"
import { getUrlTrialDaysLeft } from "../../modules/trialCode"
import { JARGON } from "../../modules/constants"

class Splash extends Component {

  constructor(props) {
    // console.log('Splash.constructor props:', props)
    super()
    const { urlSource, urlTrialCode } = analyseQuery(props)
    const daysLeft = getUrlTrialDaysLeft(urlTrialCode)

    if (urlSource === JARGON.THE350CLUB || daysLeft > 0)
      props.app.appendSpecialUserFeatures()

    initBranding(urlSource)
    props.common.saveSplash({ ...props, urlSource, daysLeft, urlTrialCode })
  }

  render() {
    return (
      <div
        className="splash-screen"
        style={{ background: this.props.brandColor }}
      >
        <div className="splash-logo" />
        <div className="splash-graphic" />
      </div>
    )
  }
}

const mapStateToProps = ({ common }) => {
  const { brandColor, checkboxes, currentUrl, nexusView, radio, searchStringObj } = common
  return {
    brandColor,
    checkboxes,
    currentUrl,
    nexusView,
    radio,
    searchStringObj,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch),
    common: bindActionCreators(commonActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Splash)
